import {
  axiosGetWithCookies,
  axiosPostWithCookies,
  axiosPutWithCookies,
} from './helper';

export const fetchBusinessClientList = ({
  securityCompanyId,
  archived,
  search,
  from,
  departmentId,
}) => {
  let query = `/users/business-clients?securityCompanyId=${securityCompanyId}&includeArchived=${archived}&limit=50`;
  if (from) query += `&from=${from}`;
  if (departmentId === 'EMPTY_DEPARTMENT') {
    query += `&departmentId=${''}`;
  } else if (Array.isArray(departmentId)) {
    /* eslint-disable no-param-reassign */
    query += departmentId.reduce((acc, s) => `${acc}&departmentId=${s}`, '');
  } else if (departmentId) {
    query += `&departmentId=${departmentId}`;
  }
  if (search) query += `&search=${search}`;
  return axiosGetWithCookies(query);
};
export const fetchBusinessClientDetail = id =>
  axiosGetWithCookies(`/users/business-clients/${id}`);
export const addBusinessClient = client =>
  axiosPostWithCookies(`/users/business-clients`, {
    data: client,
  });
export const updateBusinessClient = (id, client) =>
  axiosPutWithCookies(`/users/business-clients/${id}`, {
    data: client,
  });
